import { render } from "./ModernConfirmModal.vue?vue&type=template&id=5a19e84b&scoped=true"
import script from "./ModernConfirmModal.vue?vue&type=script&lang=js"
export * from "./ModernConfirmModal.vue?vue&type=script&lang=js"

import "./ModernConfirmModal.vue?vue&type=style&index=0&id=5a19e84b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a19e84b"]])

export default __exports__